import styled from 'styled-components';

const SubjectOwnerModalStyles = styled.div`
  .modal-footer {
    margin-top: 25px;
  }
`;

export default SubjectOwnerModalStyles;
